import { EXPORT_USERS } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case EXPORT_USERS.LOAD:
      return {
        ...state,
        loading: true
      };
    case EXPORT_USERS.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case EXPORT_USERS.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
